import { render } from "./boxed-category-list.vue?vue&type=template&id=be479db4&scoped=true&ts=true"
import script from "./boxed-category-list.vue?vue&type=script&lang=ts"
export * from "./boxed-category-list.vue?vue&type=script&lang=ts"

import "./boxed-category-list.vue?vue&type=style&index=0&id=be479db4&lang=scss&scoped=true"

import exportComponent from "/Users/brian/VIS Solutions/aeon-boxed-middleware-spa/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be479db4"]])

export default __exports__